export class CClassifier {
  active: boolean
  code: string
  enabled: boolean
  id: number
  name: string
}
